import React from 'react';

const InstallPromptComponent = () => {
    return null; // Prevents the modal from rendering
};

export default InstallPromptComponent;
